"use client";
import {
  useGroupLabel
} from "./TH2YTBRW.js";
import {
  createElement,
  createHook,
  forwardRef
} from "./5M6RSQEC.js";
import {
  __objRest
} from "./4R3V3JGP.js";

// src/composite/composite-group-label.ts
var TagName = "div";
var useCompositeGroupLabel = createHook(function useCompositeGroupLabel2(_a) {
  var _b = _a, { store } = _b, props = __objRest(_b, ["store"]);
  props = useGroupLabel(props);
  return props;
});
var CompositeGroupLabel = forwardRef(function CompositeGroupLabel2(props) {
  const htmlProps = useCompositeGroupLabel(props);
  return createElement(TagName, htmlProps);
});

export {
  useCompositeGroupLabel,
  CompositeGroupLabel
};
